window.older = false;
window.n = 0;
window.scl = 0;

window.shr = function(link){
	window.open(link, 'compartilhar', 'width=800, height=600, toolbar=no, top=50, left=50');
};

window.checkWhatsapp = function(){

	/**
	 * Checar se está na página interna do imovel / lancamento = action "ver"
	 * se estiver, mostrar o botão do whatsapp
	 */

	let actionatual = window.location.pathname.split('/')[2] ? window.location.pathname.split('/')[2] : '/';

	if(actionatual == 'ver'){

		let href_antigo = '';
		let mensagem = 'Olá, gostaria de saber mais sobre o imóvel: ' + window.location.href;
		let botoes_whats = document.querySelectorAll('.btn-menuDefault');

		for(var i = botoes_whats.length - 1; i >= 0; i--){

			href_antigo = botoes_whats[i].href + '&text=' + mensagem;
			botoes_whats[i].href = href_antigo;
		}

		if(Boss.getById('container_whatsapp')){
			Boss.getById('container_whatsapp').classList.remove('hidden');
		}
	}else {
		if(Boss.getById('container_whatsapp')){
			Boss.getById('container_whatsapp').classList.add('hidden');
		}
	}
};

window.imprimir = function(url, tipo){

	var ux_print;

	if(!Boss.getById('ux-print')){

		ux_print = document.createElement('div');
		ux_print.setAttribute('id', 'ux-print');
		ux_print.setAttribute('class', 'print no-select');

		Boss.insertAfter(ux_print, Boss.getById('push-loader'));

	}else{
		ux_print = Boss.getById('ux-print');
		ux_print.innerHTML = '';
	}

	var thm = '\
		<div class="ux-print no-select" id="ux-print">\
			<div class="ux-print-vertical">\
				<div class="ux-print-area">\
					<div class="text-center hidden" id="ux-print-gear"><img alt="gear" class="ux-print-gear" src="/jnh/gifs/gear.gif" /></div>\
					<div id="ux-print-options">\
						<form action="/imoveis/limbo" method="post" id="form-print">\
							<div class="display-inline-block width-50 block-padding-right">\
								<div class="ux-print-titulo">\
									<h3>ORIENTAÇÃO</h3>\
								</div>\
								<div class="display-inline-block width-100 ux-print-div-img">\
									<input class="boss-comp-radio" checked="checked" type="radio" id="print-portrait" value="portrait" name="orientation" />\
									<label for="print-portrait">\
										<span class="boss-comp-radio-span"></span> Retrato\
									</label>\
									<label for="print-portrait" class="block width-100 cursor-pointer">\
										<img alt="portrait" class="ux-print-img" src="/jnh/icones/print-portrait.png" />\
									</label>\
								</div>\
								<div class="site-space"></div>\
								<div class="display-inline-block width-100 ux-print-div-img">\
									<input class="boss-comp-radio" type="radio" id="print-landscape" value="landscape" name="orientation" />\
									<label for="print-landscape">\
										<span class="boss-comp-radio-span"></span>Paisagem\
									</label>\
									<label for="print-landscape" class="block width-100 cursor-pointer">\
										<img alt="landscape" class="ux-print-img" src="/jnh/icones/print-landscape.png" />\
									</label>\
								</div></div><div class="display-inline-block width-50 block-padding-left">\
								<div class="ux-print-titulo">\
									<h3>OPÇÕES</h3>\
								</div>\
								<div class="display-inline-block width-100">\
									<p>\
										<input onchange="modoPrint(this.value)" checked="checked" class="boss-comp-radio" type="radio" id="print-simplificada" value="simplificada" name="modo" />\
										<label for="print-simplificada"><span class="boss-comp-radio-span"></span> Versão simplificada</label>\
									</p>\
								</div>\
								<div class="display-inline-block width-100">\
									<p>\
										<input onchange="modoPrint(this.value)" class="boss-comp-radio" type="radio" id="print-completa" value="completa" name="modo" />\
										<label for="print-completa"><span class="boss-comp-radio-span"></span> Versão completa</label>\
									</p>\
									<div id="print-map-infra-hidden" class="hidden">\
										<p>\
											<input value="infraestruturas" name="infraestruturas" class="boss-comp-checkbox" checked="checked" type="checkbox" id="print-infraestruturas" />\
											<label for="print-infraestruturas"><span class="boss-comp-checkbox-span"></span>Infraestruturas</label>\
										</p>\
										<p>\
											<input value="map" name="map" class="boss-comp-checkbox" checked="checked" type="checkbox" id="print-mapa" />\
											<label for="print-mapa"><span class="boss-comp-checkbox-span"></span>Mapa</label>\
										</p>\
									</div>\
								</div>\
							</div>\
						</form>\
					</div>\
					<hr />\
					<p><button type="button" id="print-button-print" class="btn btn-secondary align-middle"><i class="fa fa-print" aria-hidden="true"></i> Imprimir</button> <button type="button" id="print-button-cancel" class="btn btn-secondary align-middle">Fechar <i class="fa fa-times" aria-hidden="true"></i></button></p>\
				</div>\
			</div>\
			<iframe id="iframe-imprimir" class="hidden" src="/imoveis/limbo"></iframe>\
		</div>';

	ux_print.innerHTML = thm;

	Boss.evts.add(Boss.evtTouchUp(), Boss.getById('print-button-cancel'), function(evt){
		fecharTelaImpressao();
	});

	Boss.evts.add(Boss.evtTouchUp(), Boss.getById('print-button-print'), function(evt){

		Boss.delay(function(){
			fecharTelaImpressao();
		}, 1500);

		Boss.getById('ux-print-gear').classList.remove('hidden');
		Boss.getById('ux-print-options').classList.add('hidden');

		var gets = Array();
		var seri = Boss.serializer('form-print');

		for (x in seri) { 
			gets.push(x+'='+seri[x]);
		}

		gets = gets.join('&');

		Boss.getById('iframe-imprimir').src = url+'/?'+gets;
	});

	ux_print.classList.remove('hidden');

	if(tipo == 'portrait'){
		Boss.getById('print-portrait').checked = true;
	}

	if(tipo == 'landscape'){
		Boss.getById('print-landscape').checked = true;
	}
};

function fecharTelaImpressao(){
	var ux_print = Boss.getById('ux-print');
	Boss.remover(ux_print);
}

function modoPrint(vl){
	if(vl === 'simplificada'){
		Boss.getById('print-infraestruturas').checked = false;
		Boss.getById('print-mapa').checked = false;
		Boss.getById('print-map-infra-hidden').classList.add('hidden');
	}else{
		Boss.getById('print-map-infra-hidden').classList.remove('hidden');
	}
}

function callLoginFace(rtn, uri, ctrl, imo_codigo){

	if(rtn == 'ok'){

		/* RENDERIZAR NOVAMENTE FORM CONTATO */
		var url = '?ctrl='+ctrl+'&imo_codigo='+imo_codigo+'&rerender';

		Boss.ajax({
			'url': '/favoritos/render-contato/'+url,
			'data': {},
			'dataType': 'json',
			'done': function(rtn){

				if(rtn.html){

					var ly_render_contato = Boss.getById('ly_render_contato');
					
					ly_render_contato.innerHTML = rtn.html

					Boss.delay(function(){
						var scripts = ly_render_contato.getElementsByTagName('script');
						for(x in scripts){
							eval(scripts[x].innerHTML);
						}
					}, 30);
				}
			}
		});
	}
}

function loginSair(url){

	Boss.ajax({
		'url': '/favoritos/pessoasair',
		'data': {},
		'done': function(rtn){

			window.location.href = url;
		}
	});
}

function posicaoAteTopo(el){
	posicao = -40;
	if (el.offsetParent) {
		do{
			posicao += el.offsetTop;
		} while (el = el.offsetParent);
	}
	return posicao;
}

function sizes(){
	
	var sizes = Boss.screensizes();

	if(Boss.getById('ux-print')){
		Boss.getById('ux-print').style.width = (sizes.viewWidth)+'px';
		Boss.getById('ux-print').style.height = (sizes.viewHeight)+'px';
	}
}

function getXHRPopStateShowStatus(){
	return XHRPopStateShowStatus;
}

function setXHRPopStateShowStatus(st){
	XHRPopStateShowStatus = st;
}

/* PUSH HISTORY AJAX */
var xhrfn = function(controler, doneCallFn){

	var expPopstate = /!popstate+$/g;
	var expHash = /#[.*\S]+$/g;
	var expHashExtract = /#([.*\S]+)$/i;
	var atualLocation = XHRPopLastController.replace(expHash, '');

	controler = controler.replace(expPopstate, '');
	var testHash = controler;

	controler = controler.replace(expHash, '');

	if(atualLocation != controler){

		var pushLoader = Boss.getById('push-loader');
		pushLoader.style.width = '10%';
		pushLoader.style.opacity = 1;

		var sizes = Boss.screensizes();

		if(XHRPopState){
			if(typeof(XHRPopState.abort) === 'function'){
				if(getXHRPopStateShowStatus() === false){
					console.warn('Cancelando request anterior.');
				}
				setXHRPopStateShowStatus(false);
				XHRPopState.abort();
			}
		}

		setXHRPopStateShowStatus(false);

		closeFullMenu();

		XHRPopState = Boss.ajax({
			'url': controler,
			'data': {'metodo': 'ajax', 'largura': sizes.viewWidth},
			'dataType': 'json',
			'done': function(rtn){

				XHRPopLastController = controler;

				setXHRPopStateShowStatus(true);

				doneCallFn();

				pushLoader.style.width = '50%';

				if(rtn.title){
					document.title = rtn.title;
				}

				if(rtn.jsFilters){
					Buscar.filtrar(rtn.jsFilters);
				}

				var render = Boss.getById('content');
				render.innerHTML = '';
				render.innerHTML = rtn.html;

				if(typeof(ga) !== 'undefined'){
					if(controler === jsdominio){
						gtag('config', 'UA-114219722-1', {'page_path': '/'});
					}else{
						var gasend = controler.replace(jsdominio, '');
						gasend = gasend.replace('!popstate', '');
						gtag('config', 'UA-114219722-1', {'page_path': gasend});
					}
				}

				Boss.delay(function(){

					// SCROLL TO HASH ELEMENT
					if(expHashExtract.test(testHash) === true){
						var idByHash = testHash.match(expHashExtract)[1];
						if(Boss.getById(idByHash)){
							var idByHashTop = Boss.positionAtTop(Boss.getById(idByHash));
							window.scrollTo(0, idByHashTop);
						}else{
							window.scrollTo(0, XHRPopStateScroll[testHash]);
						}
					}else{

						if(XHRPopStateScroll[controler]){
							window.scrollTo(0, XHRPopStateScroll[controler]);
						}else{
							window.scrollTo(0, 0);
						}
					}

					var scripts = render.getElementsByTagName('script');
					for(x in scripts){
						eval(scripts[x].innerHTML);
					}

					FB.XFBML.parse();
					Boss.ux.blurup();
					textFlip();

				}, 30);

				checkWhatsapp();

				/* index */
				if(controler === '/' || controler === jsdominio || controler === jsdominio+'/'){

					pushLoader.style.width = '100%';

					Boss.delay(function(){
						pushLoader.style.opacity = 0;
					}, 500);

				/* outros */
				}else{

					Boss.delay(function(){

						pushLoader.style.width = '100%';

						Boss.delay(function(){
							pushLoader.style.opacity = 0;
						}, 500);

						Boss.delay(function(){
							pushLoader.style.width = '0%';
						}, 1000);
					}, 30);
				}
			},
			'error': function(evts){
				if(getXHRPopStateShowStatus() === true){
					Boss.warning({'message': 'Não foi possível acessar o conteúdo requisitado, há algum problema com a Internet!'});
					Boss.delay(function(){
						pushLoader.style.opacity = 0;
					}, 500);

					Boss.delay(function(){
						pushLoader.style.width = '0%';
					}, 1000);
				}
			}
		});
	}
};

var lockChangePageFn = function(url){
		if(lockChangePage === true){
			Boss.confirm({
				message: lockExitMessage,
				'ok': 'Não sair',
				'no': 'Sair',
				'okFunction': function(){
				},
				'noFunction': function(){
					lockChangePage = false;
					lockClosePage = false;
					Boss.pushstate.goXHR(url, xhrfn, '');
				}
			});
		}
	};

if(navigator.userAgent.match(/MSIE 9\.0/)){
	older = true;
}

if(older === false){
	Boss.pushstate.init({
		'lockExitMessage': lockExitMessage,
		'xhrfn': xhrfn,
		'lockChangePageFn': lockChangePageFn
	});
}

window.headerInterno = function(){
	Boss.getById('header').classList.add('header_interno');
};

window.headerHome = function(){
	Boss.getById('header').classList.remove('header_interno');
};

window.buscaInterna = function(){
	Boss.getById('header').classList.add('busca_interna');
};

window.buscaHome = function(){
	Boss.getById('header').classList.remove('busca_interna');
};

window.openBusca = function(){

	window.requestAnimationFrame(closeFullMenu);

	Boss.getById('buscar_area').classList.add('hidden');
	Boss.getById('render_busca').classList.remove('hidden');

	Boss.getById('header').classList.remove('header_interno');

	var screensizes = Boss.screensizes();
	if(screensizes.resolutionWidth < 1024){
		document.body.classList.add('lock');
	}else{
		document.body.classList.remove('lock');
	}
};

window.fecharBusca = function(){

	Boss.getById('render_busca').classList.add('hidden');
	Boss.getById('buscar_area').classList.remove('hidden');

	var render_busca = Boss.getById('render_busca').classList.add('hidden');
	document.body.classList.remove('lock');

};

window.toggleBusca = function(){

	window.requestAnimationFrame(closeFullMenu);
	window.requestAnimationFrame(openBusca);

	if(Boss.getById('render_busca').classList.contains('hidden')){
		window.requestAnimationFrame(openBusca);
	}else{
		window.requestAnimationFrame(fecharBusca);
	}
};

window.openFullMenu = function(){

	var full_menu_area = Boss.getById('full_menu_area');
	full_menu_area.scrollTop = 0;
	full_menu_area.classList.add('full_menu_ativo');

	var screensizes = Boss.screensizes();
	if(screensizes.resolutionWidth < 1024){
		document.body.classList.add('lock');
	}else{
		document.body.classList.remove('lock');
	}
}

function closeFullMenu(){

	Boss.getById('full_menu_area').classList.remove('full_menu_ativo');
	document.body.classList.remove('lock');

}

function toggleFullMenu(){

	window.requestAnimationFrame(fecharBusca);

	if(Boss.getById('full_menu_area').classList.contains('full_menu_ativo')){
		window.requestAnimationFrame(closeFullMenu);
	}else{
		window.requestAnimationFrame(openFullMenu);
	}
}

window.setgrupo = function(grupo, conf){

	var grupo_input = Boss.getById('grupo_input');
	var grupo_litoral = Boss.getById('grupo_litoral');
	var grupo_rural = Boss.getById('grupo_rural');
	var grupo_urbano = Boss.getById('grupo_urbano');
	var grupo_todos = Boss.getById('grupo_todos');

	if(grupo == 'rural' || grupo == 'litoral' || grupo == 'urbano' || grupo == 'todos'){

		if(grupo == 'rural'){

			grupo_input.setAttribute('value', 'rural');
			grupo_rural.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i> RURAIS';

			grupo_rural.classList.add('btn-gray1_active');
			grupo_litoral.classList.remove('btn-gray1_active');
			grupo_urbano.classList.remove('btn-gray1_active');
			grupo_todos.classList.remove('btn-gray1_active');
			
			grupo_urbano.innerHTML = 'URBANOS';
			grupo_litoral.innerHTML = 'LITORAL';
			grupo_todos.innerHTML = 'TODOS';

		}else if(grupo == 'litoral'){

			grupo_input.setAttribute('value', 'litoral');
			grupo_litoral.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i> LITORAL';

			grupo_litoral.classList.add('btn-gray1_active');
			grupo_rural.classList.remove('btn-gray1_active');
			grupo_urbano.classList.remove('btn-gray1_active');
			grupo_todos.classList.remove('btn-gray1_active');

			grupo_todos.innerHTML = 'TODOS';
			grupo_rural.innerHTML = 'RURAIS';
			grupo_urbano.innerHTML = 'URBANOS';
			
		}else if(grupo == 'urbano'){

			grupo_input.setAttribute('value', 'urbano');
			grupo_urbano.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i> URBANOS';

			grupo_urbano.classList.add('btn-gray1_active');
			grupo_rural.classList.remove('btn-gray1_active');
			grupo_litoral.classList.remove('btn-gray1_active');
			grupo_todos.classList.remove('btn-gray1_active');

			grupo_rural.innerHTML = 'RURAIS';
			grupo_litoral.innerHTML = 'LITORAL';
			grupo_todos.innerHTML = 'TODOS';
			
		}else if(grupo == 'todos'){

			grupo_input.setAttribute('value', 'todos');
			grupo_todos.innerHTML = '<i class="fa fa-check" aria-hidden="true"></i> TODOS';

			grupo_todos.classList.add('btn-gray1_active');
			grupo_urbano.classList.remove('btn-gray1_active');
			grupo_litoral.classList.remove('btn-gray1_active');
			grupo_rural.classList.remove('btn-gray1_active');

			grupo_urbano.innerHTML = 'URBANOS';
			grupo_litoral.innerHTML = 'LITORAL';
			grupo_rural.innerHTML = 'RURAIS';
			
		}

		if(conf.trigger === true){
			Boss.trigger('input', grupo_input);
		}

	}

	openBusca();
};

window.Buscar = {

	filtrar: function(jsFilters){

		/* FILTER */
		Boss.slct.filter('search_acao', 'select-search_acao', jsFilters.acao);
		Boss.slct.filter('search_tipo', 'select-search_tipo', jsFilters.tipo);
		Boss.slct.filter('search_bairro', 'select-search_bairro', jsFilters.bairro);

		/* SET */
		setgrupo(jsFilters.set.grupo, {'trigger': false});
		Boss.slct.setValue('search_acao', 'select-search_acao', jsFilters.set.acao);
		Boss.slct.setValue('search_tipo', 'select-search_tipo', jsFilters.set.tipo);
		Boss.slct.setValue('search_bairro', 'select-search_bairro', jsFilters.set.bairro);
	},
	reset: function(){

		setgrupo('todos', {'trigger': false});
		Boss.getById('search_id').value = '';
		Boss.slct.setValue('search_acao', 'select-search_acao', '');
		Boss.slct.setValue('search_tipo', 'select-search_tipo', '');
		Boss.slct.setValue('search_bairro', 'select-search_bairro', '');

		Boss.delay(function(){
			var uri = '/imoveis/buscar';
			if(navigator.userAgent.match(/MSIE 9\.0/)){
				window.location.href = uri;
			}else{
				Boss.pushstate.goXHR(uri, xhrfn, lockChangePageFn);
			}
		}, 200);
	},
	go: function(reset){

		if(reset === false){

			var s = Boss.serializer('form_search');
			var uri = '/imoveis/buscar/?buscar';
			for(var x in s){
				uri += '&'+x+'='+s[x];
			}

			if(navigator.userAgent.match(/MSIE 9\.0/)){
				window.location.href = uri;
			}else{
				Boss.pushstate.goXHR(uri, xhrfn, lockChangePageFn);
			}
		}
	},
	buscar: function(evts, reset){

		var type = evts.type;
		var el = Boss.targt(evts);

		// CAMPOS SELECT
		if(el.nodeName === 'SELECT' && type == 'change'){

			Boss.delayPersistent2(function(){
				Buscar.go(reset);
			}, 350, 'label_select_busca1');

		// CAMPO INPUT DO ID
		}else if(el.nodeName === 'INPUT' && (type == 'keyup' || type == 'input') && el.value !== ''){

			Boss.delayPersistent2(function(){
				Buscar.go(reset);
			}, 350, 'label_id_busca1');

		// CAMPO DE  GRUPO
		}else if(el.nodeName === 'INPUT' && el.getAttribute('name') == 'grupo'){

			this.go(reset);

		}
	}
};

var Site = {
	initialF: 0,
	activeComp: {},
	renderVideo: function(json){
		Boss.delay(function(){
			for(var vv in json){
				if(Boss.getById(json[vv].id)){
					var id = Boss.getById(json[vv].id);
					id.innerHTML = '';
					var src = json[vv].src;

					var ifr = document.createElement('iframe');
					ifr.src = src;
					ifr.setAttribute('scrolling', 'no');
					ifr.setAttribute('frameborder', '0');
					ifr.setAttribute('allowTransparency', 'true');
					ifr.setAttribute('allowFullScreen', 'true');
					id.appendChild(ifr);
				}
			}
		}, 6000);
	},
	rate: function(el){
		var el = Boss.getById(el);
		var nota = el.getAttribute('data-rate');

		Site.nota(el, false);

		var divs = el.getElementsByTagName('div');
		var ldivs = divs.length;
		Boss.evts.add('mouseover', el, function(evt){
			var nt = Boss.targt(evt);
			Boss.delayPersistent2(function(){
				if(nt.getAttribute('data-nota')){
					var n = nt.getAttribute('data-nota');
					for(x = 0; x < ldivs; x++){
						if(x == (n -1)){
							divs[x].classList.add('ly_estrelas_class_nota');
						}else{
							divs[x].classList.remove('ly_estrelas_class_nota');
						}
					}
				}
			}, 16, 'ratemouseover');
		});
		Boss.evts.add('mouseout', el, function(evt){
			Boss.delayPersistent2(function(){
				Site.nota(el, false);
			}, 16, 'ratemouseout');
		});
		Boss.evts.add(Boss.evtTouchUp(), el, function(evt){
			var tg = Boss.targt(evt);
			if(tg.getAttribute('data-nota')){
				el.setAttribute('data-rate', tg.getAttribute('data-nota'));
				Site.nota(el, true);
			}
		});
	},
	addFavorito: function(a){
		Boss.ajax({
			'url': '/favoritos/adicionar',
			'data': {'a': a},
			'dataType': 'json',
			done: function(rtn){
				Boss.getById('ly_tit_addfavoritos').innerHTML = '<i class="fa fa-heart" aria-hidden="true" style="color: #f98989;"></i> adicionado!';
				Boss.getById('ly_tit_addfavoritos').classList.add('ye');
			}
		});
	},
	remFavorito: function(a, b, id){
		Boss.ajax({
			'url': '/favoritos/remover',
			'data': {'a': a, 'b': b},
			'dataType': 'json',
			done: function(rtn){
				/*if(rtn.total > 0){
					Boss.getById('label_ct_fav').textContent = '('+rtn.total+') ';
				}else{
					Boss.getById('label_ct_fav').textContent = '';
				}*/
				Boss.getById(id).classList.add('hidden');
			}
		});
	},
	nota: function(el, env){

		var nota = el.getAttribute('data-rate');
		var imovel = el.getAttribute('data-imovel');
		var divs = el.getElementsByTagName('div');
		var ldivs = divs.length;

		for(x = 0; x < ldivs; x++){
			if(x == (nota -1)){
				divs[x].classList.add('ly_estrelas_class_nota');
			}else{
				divs[x].classList.remove('ly_estrelas_class_nota');
			}
		}

		if(env === true){
			Boss.ajax({
				'url': '/favoritos/nota',
				'data': {'nota': nota, 'imovel': imovel},
				'dataType': 'json',
				done: function(rtn){

				}
			});
		}
	},
	renderContextMenu: function(obj, x, y){

		Site.removeContextMenu();

		var ctxMenu = document.createElement('div');
		ctxMenu.style.top = y+'px';
		ctxMenu.style.left = x+'px';
		ctxMenu.setAttribute('id', 'ux-context-menu');
		ctxMenu.classList.add('ux-context-menu');

		var a = document.createElement('a');
		a.innerHTML = '<i class="fa fa-external-link" aria-hidden="true"></i> Abrir em nova aba';
		a.href = obj;
		a.setAttribute('data-href', 'false');
		a.setAttribute('target', '_blank');
		ctxMenu.appendChild(a);

		Boss.evts.add(Boss.evtTouchUp(), a, function(evt){
			Boss.delay(function(){
				Site.removeContextMenu();
			}, 100);
		});

		var ap = document.createElement('a');
		ap.setAttribute('data-href', 'false');
		ap.innerHTML = '<i class="fa fa-times" aria-hidden="true"></i> fechar isto';
		ap.href = "javascript:Site.removeContextMenu()";
		ctxMenu.appendChild(ap);
		document.body.appendChild(ctxMenu);

	},
	removeContextMenu: function(){
		if(Boss.getById('ux-context-menu')){
			Boss.remover(Boss.getById('ux-context-menu'));
		}
	}
};

window.textFlip = function(){

	if(Boss.ux && Boss.ux.textFlip.init){
		Boss.ux.textFlip.init();
	}
};

function ux_scroll(scl, move){

	scl = scl - move;

	Boss.delay(function(){
		if(scl >= 1 && window.n <= 16){
			window.scrollTo(0, scl);
			window.n = window.n + 1;
			ux_scroll(scl, move);
		}else{
			window.scrollTo(0, 0);
		}
	}, 16);
}

Boss.evts.add('DOMContentLoaded', document, function(evento){
	sizes();

	Boss.evts.add(Boss.evtTouchUp(), Boss.getById('ux-to-top'), function(evt){

		window.n = 0;
		window.scl = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
		var move = (scl / 16).toFixed(0);

		ux_scroll(scl, move);
	});

	Boss.evts.add('fakescroll', window, function(evt){

		Boss.delayPersistent2(function(){

			var ux_to_top = Boss.getById('ux-to-top');
			var screensizes = Boss.screensizes();
			var scl = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
			if(scl > screensizes.resolutionHeight){
				ux_to_top.classList.remove('hidden');
			}else{
				ux_to_top.classList.add('hidden');
			}
		}, 5, 'ux-to-top');
	});
	textFlip();
});


/* DETECTA contextmenu E MOSTRA MENU AO USAR BOTÃO DIREITO */
Boss.evts.add('contextmenu', document, function(evt){

	var node = Boss.targt(evt);

	while(node !== null && evt.button === 2){
		if(node.getAttribute && node.getAttribute('data-aba') !== null){
			if(evt.stopPropagation){
				evt.stopPropagation();
			}
			if(evt.preventDefault){
				evt.preventDefault();
			}
			Site.renderContextMenu(node.getAttribute('data-aba'), evt.clientX, evt.clientY);
			return true;
		}
		node = node.parentNode;
	}

	if(Boss.getById('ux-context-menu')){
		Site.removeContextMenu();
	}

});

/* REMOVE contextmenu*/
Boss.evts.add(Boss.evtTouchUp(), document, function(evt){
	if(evt.button !== 2 && Boss.getById('ux-context-menu') && !Boss.isChild(Boss.getById('ux-context-menu'), Boss.targt(evt))){
		Site.removeContextMenu();
	}
});

/* REMOVE contextmenu on scroll */
Boss.evts.add('fakescroll', window, function(evt){
	Site.removeContextMenu();
});

/* MOUSE "FORA" DO SITE*/
Boss.evts.add('mouseout', document, function(evt){

	var from = evt.relatedTarget || evt.toElement;

	if((!from || from.nodeName == 'HTML' || evt.clientY < 1) && Boss.getById('ux-context-menu')){
		Site.removeContextMenu();
	}
});

window.fullMR = function(){
	Boss.getById('mmovel-rural').classList.remove('hidden');
	Boss.getById('mmovel-urbanos').classList.add('hidden');
	Boss.getById('mmovel-servicos').classList.add('hidden');
};

window.fullMU = function(){
	Boss.getById('mmovel-rural').classList.add('hidden');
	Boss.getById('mmovel-urbanos').classList.remove('hidden');
	Boss.getById('mmovel-servicos').classList.add('hidden');
};

window.fullMS = function(){
	Boss.getById('mmovel-rural').classList.add('hidden');
	Boss.getById('mmovel-urbanos').classList.add('hidden');
	Boss.getById('mmovel-servicos').classList.remove('hidden');
};

Boss.evts.add(Boss.evtTouchUp(), Boss.getById('print-button-cancel'), function(evt){
	Boss.getById('ux-print').classList.add('hidden');
});

Boss.evts.add(Boss.evtTouchUp(), Boss.getById('toggle-busca'), function(evt){
	window.requestAnimationFrame(toggleBusca);
});

Boss.evts.add(Boss.evtTouchUp(), Boss.getById('toggle-busca-m'), function(evt){
	window.requestAnimationFrame(toggleBusca);
});

Boss.evts.add(Boss.evtTouchUp(), Boss.getById('full-menu'), function(evt){
	window.requestAnimationFrame(toggleFullMenu);
});

Boss.evts.add(Boss.evtTouchUp(), Boss.getById('full-menu-m'), function(evt){
	window.requestAnimationFrame(toggleFullMenu);
});

Boss.evts.add('fakeresize', window, function(evts){
	sizes();
});

(function(){
	Boss.ux.blurup();
	textFlip();
}());